import { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { addFrequencyAnswer, selectFrequencyAnswers } from '@/store/reducers/survey/surveySlice';
import FrequencyForm from '@/components/forms/FrequencyForm';
import BagImage from '@/assets/images/bag.png';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import analytics from '@/utils/analytics/analyticsInstance';

const FrequencyPage: FC = () => {
  const { next } = useSurveyNavigate();
  const dispatch = useAppDispatch();
  const answers = useAppSelector(selectFrequencyAnswers);
  const question = 'How often do you shop online each month?';

  const handleSubmit = (answer: string) => {
    dispatch(addFrequencyAnswer({ question, answer }));

    setTimeout(() => {
      next();
      analytics.track('webOnboardingQuestionAnswered', {
        question,
        answer,
      });
    }, 1000);
  };

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: question,
    });
  }, []);

  return (
    <FrequencyForm
      title={question}
      options={[
        { question: '1', answer: '0' },
        { question: '2', answer: '1-2' },
        { question: '3', answer: '3-4' },
        { question: '4', answer: '5+' },
      ]}
      selectedAnswer={(answers[0]?.answer as string) || ''}
      image={BagImage}
      onSelect={handleSubmit}
    />
  );
};

export default FrequencyPage;
